import * as Styled from './AddToProjectsModal.styles'

import {
	Heading,
	Modal,
	Paragraph,
	Tabs,
} from '@audio-network/componentlibrary'
import React, { useCallback, useEffect, useState } from 'react'

import { Trans, useTranslation } from 'next-i18next'
import AddToProjectsExistingForm from './AddToProjectForms/AddToProjectsExistingForm'
import AddToProjectsNewForm from './AddToProjectForms/AddToProjectsNewForm'
import { getCurrentProjects } from '../../../services/projectsService'

type Props = {
	isOpen: boolean
	onClose: () => void
	tracks: Track[]
	source: string
	onSuccess?: () => void
}

export default function AddToProjectsModal({
	isOpen,
	onClose,
	onSuccess,
	tracks,
	source,
}: Props): JSX.Element {
	const [projects, setProjects] = useState<Project[]>(null)

	const { t } = useTranslation(['addtoproject'])

	const fetchData = useCallback(async (): Promise<void> => {
		setProjects(null)

		const projectsData = await getCurrentProjects(1, 100, 0, 0)
		setProjects(projectsData)
	}, [])

	useEffect(() => {
		if (isOpen) {
			fetchData()
		}
	}, [fetchData, isOpen])

	const TrackInfoHelper = (): JSX.Element => {
		let trackInfo
		if (tracks?.length === 1) {
			trackInfo = tracks[0].title
		} else {
			trackInfo = t('tracks-info', { tracksLength: tracks?.length })
		}

		return (
			<Paragraph data-testid="trackInfo">
				<Trans components={{ bold: <Styled.TrackInfoStrong /> }}>
					{t('add-message', { trackInfo: trackInfo })}
				</Trans>
			</Paragraph>
		)
	}

	return (
		<Modal
			id="add-all-to-project"
			isOpen={isOpen}
			onClose={onClose}
			closeButtonLabel="Close"
			css={{ minHeight: '24rem' }}
		>
			{isOpen && (
				<div>
					<Heading level={2} size="M" uppercase>
						{t('title')}
					</Heading>
					<TrackInfoHelper />
					<Tabs
						tabs={
							projects?.length != 0
								? [
										{
											title: t('existing-project'),
											content: (
												<AddToProjectsExistingForm
													tracks={tracks}
													onClose={() => {
														onClose()
														onSuccess && onSuccess()
													}}
													projects={projects}
													source={source}
												/>
											),
										},
										{
											title: t('new-project'),
											content: (
												<AddToProjectsNewForm
													tracks={tracks}
													onClose={() => {
														onClose()
														onSuccess && onSuccess()
													}}
													source={source}
												/>
											),
										},
								  ]
								: [
										{
											title: t('new-project'),
											content: (
												<AddToProjectsNewForm
													tracks={tracks}
													onClose={() => {
														onClose()
														onSuccess && onSuccess()
													}}
													source={source}
												/>
											),
										},
								  ]
						}
					/>
				</div>
			)}
		</Modal>
	)
}
